<template>
  <section v-if="enableHeroCommunity && isCommunityEnabled" :id="`uuid-${$attrs.uuid}`" :class="['hero-heading-community', {'no-media' : !heroCommunityMedia}]">
    <div class="hero-heading-community__container">
      <div v-if="isHostName && common.communityData.heroCommunityBackRedirect" :class="['back-button', {'hero-active' : isHeroActive}]">
        <a :href="backRedirect" class="back-button-link"><msg id="common.heroHeading.community.back.button"/></a>
      </div>
      <div v-if="enableLogo" class="hero-heading-community__section-logo">
        <div class="container-section-logo">
          <a :href="common.communityData.homePageCommunity" class="section-logo-link">
            <picture v-if="common.communityData.heroCommunityLogo">
              <source
                  media="(min-width:0) and (max-width:640px)"
                  :srcset="common.communityData.heroCommunityLogo | mgnlMedia('url')"
                  v-if="common.communityData.heroCommunityLogo"
              />
              <pg-image
                  class="logo-section-img"
                  :style="logoHeight"
                  :lazy-src="common.communityData.heroCommunityLogo | mgnlMedia('url')"
                  alt="hero-heading-community-logo"
              />
            </picture>
          </a>
          <h1 v-if="common.communityData.heroCommunityLogo" class="hero-heading-title">{{ common.communityData.heroCommunityLogoTitle }}</h1>
          <h3 v-else class="hero-heading-title">{{ common.communityData.heroCommunityLogoTitle }}</h3>
        </div>
      </div>
      <picture v-if="heroCommunityMedia" :class="['hero-heading-community__picture', {'is-overlay' : mediaOverlay}]" :style="aspectRatio">
        <div :class="`hero-heading-community__info-container ${heroCommunityAlignCenter ? 'align-center' : ''}`">
          <div class="hero-heading-info-container-flex" :style="marginRef">
            <div class="hero-heading-info" :class="[{'no-dates' : !eventStartDate}, {' flex' : !isCtaConfigured}]">
              <div v-if="title && heroCommunityMedia" class="hero-heading-title" :class="{' title-only' : !isCtaConfigured}">
                <h1 v-if="titleStyle" class="event-title-text">{{ title }}</h1>
                <h3 v-else class="event-title-text">{{ title }}</h3>
              </div>
              <div v-if="isCtaConfigured" class="hero-heading-community-ctas-links">
                <template v-for="ctaObj in heroCtaLinks" >
                  <advanced-button-wrapper
                      class="hero-heading-cta-link"
                      :key="ctaObj.uuid"
                      :cta-obj="ctaObj"
                      color="primary"
                      styleType="text"
                      size="medium"
                      :analyticsData="analyticsData(ctaObj)" />
                </template>
              </div>
            </div>
            <div v-if="eventStartDate || eventEndDate" class="hero-heading-dates" ref="dates">
              <div v-if="eventStartDate" class="start-date" :class="{'separator' : eventEndDate}">
                <div class="container-start-date">
                  <span class="date-field-day">{{eventStartDateObj.day}}</span>
                  <span class="date-field-month">{{eventStartDateObj.month}}</span>
                </div>
              </div>
              <div v-if="eventEndDate" class="end-date">
                <div class="container-start-date">
                  <span class="date-field-day">{{eventEndDateObj.day}}</span>
                  <span class="date-field-month">{{eventEndDateObj.month}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <source
            media="(min-width:0) and (max-width:640px)"
            :srcset="heroCommunityMediaMobile | mgnlMedia('url')"
            v-if="heroCommunityMediaMobile"
        />
        <source
            v-else
            media="(min-width:641px)"
            :srcset="heroCommunityMedia | mgnlMedia('url')"
        />
        <pg-image
            v-if="heroCommunityMedia"
            :lazy-src="isMobileImage | mgnlMedia('url')"
            alt="hero-heading-community-image"
        />
      </picture>
      <!-- Show Title if HeroCommunity Media isn't configured -->
      <div v-if="!heroCommunityMedia && common.communityData.heroCommunityBackRedirect" :class="`hero-heading-community__info-container ${heroCommunityAlignCenter ? 'align-center' : ''}`">
        <div class="hero-heading-info-container-flex" :style="marginRef">
          <div class="hero-heading-info" :class="[{'no-dates' : !eventStartDate}, {' flex' : !isCtaConfigured}]">
            <div v-if="title" class="hero-heading-title" :class="{' title-only' : !isCtaConfigured}">
              <h1 v-if="titleStyle" class="event-title-text"></h1>
              <h3 v-else class="event-title-text">{{ title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- -->
  </section>
</template>

<script>
import PgImage from "../Image/Image.vue";
import advancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "HeroHeadingCommunity",
  components: {
    PgImage,
    advancedButtonWrapper
  },

  data() {
    return {
      logoHeight: "",
      aspectRatio: "",
      marginRef: "",
      backRedirect: "",
      eventStartDateObj: {
        day: "",
        month: ""
      },
      eventEndDateObj: {
        day: "",
        month: ""
      },
      userLogged: false
    }
  },

  props: {
    enableHeroCommunity: {
      type: Boolean,
      default: false
    },
    enableLogo: {
      type: Boolean,
      default: false
    },
    mediaOverlay: {
      type: Boolean,
      default: false
    },
    heroCommunityMedia: {
      type: Object,
      default: () => {
      }
    },
    heroCommunityMediaMobile: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
    },
    textForLoggedUser: {
      type: String,
    },
    heroCtaLinks: {
      type: Array,
      default: () => []
    },
    heroCommunityAlignCenter: {
      type: Boolean,
      default: false,
    },
    eventStartDate: {
      type: String,
      default: ""
    },
    eventEndDate: {
      type: String,
      default: ""
    }
  },

  computed: {
    isMobile() {
      return window.matchMedia('only screen and (max-width: 640px)').matches;
    },
    isMobileImage() {
      return this.isMobile && this.heroCommunityMediaMobile ? this.heroCommunityMediaMobile : this.heroCommunityMedia;
    },
    isCtaConfigured() {
      return this.heroCtaLinks.length > 0;
    },
    isThemeMotoGuzzi() {
      return document.body.classList.contains('theme-moto-guzzi');
    },
    isThemeAprilia() {
      return document.body.classList.contains('theme-aprilia');
    },
    isCommunityEnabled() {
      return this.common.communityData.isCommunityEnabled;
    },
    isHostName(){
      return document.referrer.includes(this.$root.commonData.currentHost);
    },
    isHeroActive() {
      return document.body.classList.contains('hero-active');
    },
    titleStyle() {
      return !this.common.communityData.heroCommunityLogo;
    },
    titleForLoggedUser() {
      return this.common.communityData.heroCommunityLogoTitleForLoggedUser;
    },

  },

  created() {
    this.setAspectRatio();
    this.setLogoHeightByBrand();
    this.datesRefWidth();
  },

  mounted() {
    this.eventDateObj(this.eventStartDate, this.eventEndDate);
    this.isHostName ? this.backRedirect = document.referrer : '';
    if(this.checkUserLogged()){
      if (this.common.communityData.isEditorialCommunityPage){
        this.changesForUserLogged();
      }

    }
  },

  updated() {
    this.$nextTick(() => {
      this.datesRefWidth();
    });
  },

  methods: {
    eventDateObj(startDate, endDate) {
      let heroEventStart = startDate.replace(" ", "");
      let heroEventEnd = endDate.replace(" ", "");

      this.eventStartDateObj = {
        day: heroEventStart.slice(0,2),
        month: heroEventStart.slice(2, 5)
      }
      this.eventEndDateObj = {
        day: heroEventEnd.slice(0,2),
        month: heroEventEnd.slice(2, 5)
      }
    },
    async changesForUserLogged(){
      document.querySelector('.hero-heading-community-ctas-links') ? document.querySelector('.hero-heading-community-ctas-links').remove() : '';
      document.querySelector('.event-title-text').textContent = this.textForLoggedUser ? this.textForLoggedUser : this.title
    },
    checkUserLogged(){
      if (localStorage.user){
        this.userLogged = true
        return true
      }
      else {
        this.userLogged = false
        return false
      }
    },
    setAspectRatio() {
      let isMobile = window.matchMedia('only screen and (max-width: 640px)').matches;
      this.aspectRatio = isMobile ? "--aspect-ratio: 3/4;" : "--aspect-ratio: 21/9;"
    },
    datesRefWidth() {
      const refWidth = `${this.$refs.dates?.getBoundingClientRect().width + 40}px`;
      this.marginRef =  this.heroCommunityAlignCenter && this.$refs.dates ? `--margin-left: ${refWidth}` : "--margin-left: 4rem";
    },
    setLogoHeightByBrand() {
      this.logoHeight = this.isThemeAprilia ? "--logo-height: 60px"
                        : this.isThemeMotoGuzzi ? "--logo-height: 90px"
                        : "--logo-height: 60px"; //Provisory logo height for non moto-guzzi & aprilia brands
    },
    analyticsData(el) {
      return {
        evCategory: 'hero_heading_community',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    },
  }
}


</script>